import { ReportsView } from '../../features/reports/ReportsView'

/** S9 Reports (investor). */
export function ReportsPage() {
  return <ReportsView area="app" />
}
